export default __webpack_public_path__ + "static/media/abaddoronwarrior.224b4f78.png";